import { createReducer } from "reduxsauce"
import actionCreator from "helpers/actionCreator"
import { get } from "lodash"
import { Types as LoaderTypes } from "model/data"

export const { Types, Creators } = actionCreator("ompnt/modules/default-metric-units", {
  updateDefaultMetrics: {
    props: ["metrics"],
    updatePreference: {
      getItems: (state, { metrics }) => [{
        type: "defaultMetricUnits",
        key: get(state, "global.selected.accountId"),
        accountId: get(state, "global.selected.accountId"),
        value: metrics,
      }],
    },
  },
})

const DEFAULT_STATE = {}

function handleLoadSuccess(state, action) {
  if (action.resource === "userDefaultMetricUnits") {
    return {
      ...DEFAULT_STATE,
      ...get(action, "data.0.value", {}),
    }
  }
  return state
}

function handleUpdateDefaultMetrics(state, { metrics }) {
  return {
    ...state,
    ...metrics,
  }
}

export default createReducer(DEFAULT_STATE, {
  [LoaderTypes.LOAD_SUCCESS]: handleLoadSuccess,
  [Types.UPDATE_DEFAULT_METRICS]: handleUpdateDefaultMetrics,
})
